import Image from 'next/image';
import getFlagLink from '@/utils/getFlagLink';
import React from 'react';

const CountryFlag = ({
	countryName,
	countryISO,
}: {
	countryName?: string;
	countryISO?: string;
}) =>
	countryISO ? (
		<span className="flag h-fit">
			<Image
				src={getFlagLink(countryISO)}
				alt={countryName || ''}
				width={20}
				height={6}
			/>
		</span>
	) : null;

export default CountryFlag;